import { portalRouter } from './modules';
import indexLayout from '../indexLayout';
export const RouterList = [
    {
        path: '/',
        name: 'home',
        redirect: '/',
        component: indexLayout,
        children: [...portalRouter]
        // component: () => import('../views/dashboard/Dashboard.vue')
    }
]